export default __webpack_public_path__ + "static/media/cp-ic-messages.70b9ee3d.svg";